import { render, staticRenderFns } from "./SearchResultClinic.vue?vue&type=template&id=2a098250&"
import script from "./SearchResultClinic.vue?vue&type=script&lang=js&"
export * from "./SearchResultClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports